var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M1 .7h22v22.6H1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 18.2l-1-.9C7.6 14.1 5.4 12 5.4 9.5c0-2 1.5-3.7 3.6-3.7h.1c1.2 0 2.2.5 3 1.4.7-.9 1.8-1.4 3-1.4 2 0 3.6 1.7 3.6 3.7v.1c0 2.6-2.2 4.7-5.6 7.9l-1.1.7z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcHeart);
export default __webpack_public_path__ + "static/media/ic_heart.629fa7f6e036e1e279ab287da385ccba.svg";
export { ForwardRef as ReactComponent };